import React, {useState, useContext, useEffect} from "react";
import {Col, Row} from "react-bootstrap";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { RequestContext } from "../../context/RequestContext";
import { UserContext } from "../../context/UserContext";
import _ from "lodash";
import JobUtils from "../../utils/JobsUtils";
import { ContentProtectionModal } from '../../utils/String';
import SummaryUtils from "../../utils/SummaryUtils";
import ContentProtection from "../request/ContentProtection";
import RequestUtils from "../../utils/RequestUtils";
import {RedButton, GreenButton } from "../../styles/BootstrapStyles";
import "../../styles/form.scss";
import Moment from "moment";

const headers = [
    { label: "Sources", type: "source", value: "source" },
    { label: "Processing", type: "processor", value: "processor" },
    { label: "Deliveries", type: "delivery", value: "delivery" },
    { label: "Request Id", value: "requestId" },
];

const FormRequestSummary = () => {
    const {
        jobs,
        requestId,
        sourceLocation,
        needContentProtection,
        contentProtection,
        _setContentProtection,
        isStitch,
        requestName,
        dueDate,
        dueTime,
        jobType,
        contacts,
        notes,
        requestor
    } = useContext(RequestContext);
    const { faspexAccountMapping } = useContext(UserContext);

    const [indexValue, setIndex] = useState(0);
    const [order, setOrder] = useState("asc");
    const [showCPForm, setShowCPForm] = useState(false);


    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    function sortByColumn(a, colIndex) {
        const getValue = _.get(headers[colIndex], "value");
        const sortedArray = a.sort(sortFunction);
        function sortFunction(aParam, bParam) {
            aParam = JSON.stringify(_.get(aParam, getValue, ""), null, 1).toLowerCase();
            bParam = JSON.stringify(_.get(bParam, getValue, ""), null, 1).toLowerCase();
            if (_.isEqual(aParam, bParam)) {
                return 0;
            } else {
                if (order === "desc") {
                    return aParam > bParam ? -1 : 1;
                } else {
                    return aParam < bParam ? -1 : 1;
                }
            }
        }
        return sortedArray;
    }

    const renderDeliveryItem = (updateDel, job) => {
        if (_.get(updateDel, "deliveryOption") === 'Screeners.com') {
            updateDel.episodeCliptitle = _.get(job && job.processor, "outputFilename");
        }
        if (_.get(updateDel, "deliveryOption") === 'Drive' && _.get(updateDel, "driveFormatting") === 'Windows (FAT32)') {
            updateDel.driveFormatting = 'Windows (NTFS)';
        }
        const deliveryMethod = _.find(JobUtils.getJobSpecificDeliveryTypes(_.get(job, "jobType")), (delivery) => {
            return (
                _.camelCase(_.get(delivery, "label")) === _.camelCase(_.get(updateDel, "deliveryOption"))
            );
        });

        const deliveryHeaders = JobUtils.filterS3OnlyHeaders(
            SummaryUtils.getHeaders({
                metadata: _.get(deliveryMethod, "metadata"),
                overrideMetadata: _.get(deliveryMethod && deliveryMethod.override, "metadata"),
                readOnlyMetadata: _.get(deliveryMethod, "readOnlyMetadata"),
                overrideReadOnlyMetadata: _.get(deliveryMethod && deliveryMethod.override, "readOnlyMetadata")
            }, updateDel),
            _.get(updateDel, "account"),
            faspexAccountMapping
        );
        return _.map(deliveryHeaders, (column, index) => {
            return SummaryUtils.hasEmptyFields(column.fields, updateDel) ? null : (
                <React.Fragment key={index}>
                    <div className="jobSummaryLabel">
                        <span className="jobSummarySpanLabel">
                            {column.label + ":"}
                        </span>
                        <span className="jobSummarySpanValue">
                            {SummaryUtils.getValue(column.fields, updateDel)}
                        </span>
                    </div>
                </React.Fragment>
            );
        });
    };

    const renderTable = (job, header) => {
        const value = _.get(job, header.value, "");
        const type = _.get(header, "type");
        switch (type) {
            case "source":
                const sourceList = isStitch ? _.get(job, "source.simpleJobAssets") : [_.get(job, "source")];
                const list = _.map(sourceList, (source) => {
                    const fields = _.map(
                        SummaryUtils.getHeaders({
                            metadata: _.get(sourceLocation, "metadata"),
                            overrideMetadata: _.get(sourceLocation, "override.metadata"),
                            readOnlyMetadata: _.get(sourceLocation, "readOnlyMetadata"),
                            overrideReadOnlyMetadata: _.get(sourceLocation, "override.readOnlyMetadata")
                        }, source),
                        (column, index) => {
                            const valueData = SummaryUtils.getValue(
                                column.fields,
                                JobUtils.updateSourceField(source)
                            );
                            return SummaryUtils.hasEmptyFields(
                                column.fields,
                                JobUtils.updateSourceField(source)
                            ) ? null : (
                                <div
                                    className="jobSummaryLabel"
                                    style={{ color: column.color && valueData === 'Yes' ? column.color : 'inherit' }} key={"request_modal_soure" + index}>
                                    <span className="jobSummarySpanLabel">{column.label + ":"}</span>
                                    <span className="jobSummarySpanValue">{valueData}</span>
                                </div>
                            );
                        }
                    );
                    return isStitch ? (<div style={{ marginTop: "5px" }}>
                        {fields}
                    </div>) : fields;
                });
                return isStitch ? <>
                    <span className="stitchSpan">Stitched Source Assets:</span>
                    {list}
                </> : list;
              
            case "processor":
                const processingHeaders = SummaryUtils.getProcessorHeaders(job, JobUtils.updateProcess(value));
                const processHeader = JobUtils.orderProcessingSummary(processingHeaders,job);
                const processLabel = JobUtils.getSelectedProcessingTypeLabel(job);
                return (
                    <React.Fragment key={"request_modal_processor"}>
                        {processLabel ? <span className="jobSummaryJobType">
                            {job && job.jobType === 'WB_SCREENERS' ? 'WBD Screeners MP4 (1080)' : processLabel}
                        </span> : null}
                        {_.map(processHeader,
                            (column, index) => {
                                return SummaryUtils.hasEmptyFields(
                                    column.fields,
                                    JobUtils.updateProcess(value)
                                ) ? null : (
                                    <React.Fragment key={index}>
                                        <div
                                            className="jobSummaryLabel">
                      <span className="jobSummarySpanLabel">
                        {column.label + ":"}
                      </span>
                                            <span className="jobSummarySpanValue">
                        {SummaryUtils.getValue(column.fields, JobUtils.updateProcess(value))}
                      </span>
                                        </div>
                                    </React.Fragment>
                                );
                            }
                        )}
                    </React.Fragment>
                );
               
            case "delivery":
                // TO DO - So many places and it is the same code. Needs refactoring.
                const groupedDeliveries = _.groupBy(_.map(value, delivery => ({...JobUtils.updateDelivery(delivery)})), "deliveryOption");
                return _.map(groupedDeliveries, (dels, delName) => {
                    return (
                        <React.Fragment key={"delivery_modal" + delName}>
                            <span className="jobSummaryJobType">
                                {SummaryUtils.getDeliveryLabel({ deliveryOption: delName })}
                            </span>
                            {_.map(dels, (updateDel) => renderDeliveryItem(updateDel, job))}
                            {_.size(value) > 1 ? <br /> : null}
                        </React.Fragment>
                    )
                });
            
            default:
                return requestId;
        }
    };

    return (
        <>
            <Row
                className="align-items-center jobSummaryRow">
                <span className="jobSummarySpan">
                  Jobs Summary
                </span>
            </Row>

            {needContentProtection.length > 0 ? (
                <Row className="m-0">
                    <span className="contentProtectionDescription">
                      {ContentProtectionModal.Desc}
                    </span>
                    {
                        <ContentProtection
                            show={showCPForm}
                            items={needContentProtection}
                            data={JSON.parse(JSON.stringify(contentProtection))}
                            fields = {RequestUtils.getMetaDataField(
                                [
                                    "hboProductionExec",
                                    "audienceSize",
                                    "recipientCategory",
                                    "reason",
                                ],
                                sourceLocation,
                                []
                            )}
                            onClose={() => {
                                _setContentProtection(Object.assign({}, contentProtection));
                                setShowCPForm(false);
                            }}
                            onSave={(data) => {
                                _setContentProtection(Object.assign({}, data));
                                setShowCPForm(false);
                            }}
                        />
                    }
                    {(Object.keys(contentProtection).length === needContentProtection.length) ?
                        (<GreenButton
                            onClick={() => {
                                setShowCPForm(true);
                            }}
                            className="my-2"
                            id={"content-protection-btn"}>
                            {ContentProtectionModal.Heading}
                        </GreenButton>) :
                        <RedButton
                            onClick={() => {
                                setShowCPForm(true);
                            }}
                            className="my-2"
                            id={"content-protection-btn"}>
                            {ContentProtectionModal.Heading}
                        </RedButton>}
                </Row>) : null}

            <Row className="mx-0 mt-0 mb-3 p-0">
                <Col xs={4}>
                    <Row className="jobSummaryHeaderRow">
                        <label className="jobSummaryHeaderLabel">Request Name:</label>
                        <span className="jobSummaryHeaderSpan">{requestName}</span>
                    </Row>
                    <Row className="jobSummaryHeaderRow">
                        <label className="jobSummaryHeaderLabel">Due Date:</label>
                        <span className="jobSummaryHeaderSpan">{Moment(dueDate).format("MM/DD/YY")}</span>
                    </Row>
                    <Row className="jobSummaryHeaderRow">
                        <label className="jobSummaryHeaderLabel">Due Time:</label>
                        <span className="jobSummaryHeaderSpan">{dueTime}</span>
                    </Row>
                </Col>
               
                <Col xs={4}>
                    <Row className="jobSummaryHeaderRow">
                        <label className="jobSummaryHeaderLabel">Job Type:</label>
                        <span className="jobSummaryHeaderSpan">{_.get(jobType, "jobType")==='WB_SCREENERS'?_.get(jobType, "label"):_.get(jobType, "jobType") }</span>
                    </Row>
                    <Row className="jobSummaryHeaderRow">
                        <label className="jobSummaryHeaderLabel">Source Location:</label>
                        <span className="jobSummaryHeaderSpan">{_.get(sourceLocation, "label")}</span>
                    </Row>
                    <Row className="jobSummaryHeaderRow">
                        <label className="jobSummaryHeaderLabel">CC on Notifications: </label>
                        <span className="jobSummaryHeaderSpan">{contacts.join(",")}</span>
                    </Row>
                </Col>

                <Col xs={4}>
                    <Row className="jobSummaryHeaderRow">
                        <label className="jobSummaryHeaderLabel">Created By: </label>
                        <span className="jobSummaryHeaderSpan">{_.get(requestor, "fullName")} </span>
                        <a style={{ color: "rgb(44, 130, 190)" }} href={"mailto:" + _.get(requestor, "email")}>
                           {_.get(requestor, "email")}
                        </a>
                    </Row>
                    <Row className="jobSummaryHeaderRow">
                        <label className="jobSummaryHeaderLabel">Notes: </label>
                        <span className="jobSummaryHeaderSpan">{notes}</span>
                    </Row>
                </Col>
            </Row>

            <TableContainer id={"Request_modal_container"} className="tableContainer">
                <Table
                    stickyHeader
                    aria-label="sticky table"
                    id={"request-table"}>
                    <TableHead id={"request-table-head"}>
                        <TableRow key={"request_header_row"}>
                            {/* //TO DO: Table body */}
                            {headers.map((column, index) => (
                                <TableCell key={"request_head" + index} className="tableHeader">
                                    <TableSortLabel
                                        active={indexValue === index}
                                        direction={order === "asc" ? "asc" : "desc"}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            if (indexValue === index) {
                                                order === "asc" ? setOrder("desc") : setOrder("asc");
                                            } else {
                                                setOrder("asc");
                                            }
                                            setIndex(index);
                                        }}
                                    >
                                        {column.label}
                                    </TableSortLabel>
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {sortByColumn(jobs, indexValue).map((job, key) => {
                            return (
                                <TableRow key={"request_modal_row" + key}>
                                    {headers.map((header, index) => {
                                        return (
                                            <TableCell className="formTableRow" key={"viewTable" + index}>
                                                {renderTable(job, header)}
                                            </TableCell>
                                        );
                                    })}
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    );
};
FormRequestSummary.defaultProps = {
    styles: {},
};
export default React.memo(FormRequestSummary);
